<div class="toast-host" aria-live="polite" aria-relevant="additions removals">
  <div class="toast-stack">
    <div
      class="toast-card"
      *ngFor="let t of (toast.toasts$ | async); trackBy: trackById"
      [class.success]="t.type === 'success'"
      [class.error]="t.type === 'error'"
      [class.warning]="t.type === 'warning'"
      [class.info]="t.type === 'info'"
      role="status"
    >
      <div class="toast-icon" aria-hidden="true">
        <span *ngIf="t.type === 'success'">✓</span>
        <span *ngIf="t.type === 'error'">!</span>
        <span *ngIf="t.type === 'warning'">⚠</span>
        <span *ngIf="t.type === 'info'">i</span>
      </div>
      <div class="toast-body">
        <div class="toast-title" *ngIf="t.title">{{ t.title }}</div>
        <div class="toast-message">{{ t.message }}</div>
      </div>
      <button type="button" class="toast-close" (click)="dismiss(t.id)" aria-label="Dismiss notification">
        ×
      </button>
      <div class="toast-progress" [style.animationDuration.ms]="t.durationMs"></div>
    </div>
  </div>
</div>

